import React from 'react'
import { Link } from 'react-router-dom'
import AuthLayout from '../../custom/components/templates/AuthLayout'
import './Registration.css'
import Layout from '@/custom/components/templates/Layout'

const RegisterSuccessSeller = () => {
    return (
        <Layout>
            {' '}
            <div className="register-success text-center mt-4">
                <img src="/assets/svg/CheckCircle.svg" />
                <h4 className="reg-success-head">Thank you for registering as a seller!</h4>
                <p className="reg-success-note">
                    Thanks for Registering as a seller! Ready to start sell? Good luck! If you need
                    assistance, we&#39;re here. Happy Bidding!
                </p>
                <div className="mt-5 py-5">
                    <Link to="/seller/dashboard" className="reg-trans-btn">
                        Seller Dashboard
                    </Link>
                </div>
            </div>
        </Layout>
    )
}

export default RegisterSuccessSeller
